import { create } from 'zustand';

type Channel = 'pstn' | 'whatsapp';

interface StartCallParams {
  contactId: string;
  contactName: string;
  contactPhone: string;
  configurationId: string;
  channel: Channel;
  callId: string;
  callSid: string;
  wsPath: string;
  wsToken: string;
}

interface ActiveCallState {
  isActive: boolean;
  contactId: string | null;
  contactName: string | null;
  contactPhone: string | null;
  configurationId: string | null;
  channel: Channel | null;
  callId: string | null;
  callSid: string | null;
  wsPath: string | null;
  wsToken: string | null;
  minimized: boolean;
  position: { x: number; y: number };
  // Actions
  startCall: (params: StartCallParams) => void;
  endCall: () => void;
  setMinimized: (v: boolean) => void;
  setPosition: (pos: { x: number; y: number }) => void;
}

const getDefaultPosition = () => ({
  x: typeof window !== 'undefined' ? window.innerWidth - 420 : 600,
  y: typeof window !== 'undefined' ? window.innerHeight - 600 : 200,
});

export const useActiveCallStore = create<ActiveCallState>((set) => ({
  isActive: false,
  contactId: null,
  contactName: null,
  contactPhone: null,
  configurationId: null,
  channel: null,
  callId: null,
  callSid: null,
  wsPath: null,
  wsToken: null,
  minimized: false,
  position: getDefaultPosition(),
  startCall: (params) =>
    set({
      isActive: true,
      contactId: params.contactId,
      contactName: params.contactName,
      contactPhone: params.contactPhone,
      configurationId: params.configurationId,
      channel: params.channel,
      callId: params.callId,
      callSid: params.callSid,
      wsPath: params.wsPath,
      wsToken: params.wsToken,
      minimized: false,
      position: getDefaultPosition(),
    }),
  endCall: () =>
    set({
      isActive: false,
      contactId: null,
      contactName: null,
      contactPhone: null,
      configurationId: null,
      channel: null,
      callId: null,
      callSid: null,
      wsPath: null,
      wsToken: null,
      minimized: false,
    }),
  setMinimized: (v) => set({ minimized: v }),
  setPosition: (pos) => set({ position: pos }),
}));
